import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const separatorVariants = cva('shrink-0 bg-border', {
	variants: {
		color: {
			indigo: 'bg-indigo-200 dark:bg-gray-700',
			red: 'bg-red-200 dark:bg-red-700',
			green: 'bg-green-200 dark:bg-green-700',
			gray: 'bg-gray-200 dark:bg-gray-700',
		},
		orientation: {
			horizontal: 'h-[1px] w-full',
			vertical: 'h-full w-[1px]',
		},
		size: {
			smH: 'h-2',
			mdH: 'h-4',
			lgH: 'h-6',
			smW: 'w-2',
			mdW: 'w-4',
			lgW: 'w-6',
		},
	},
	defaultVariants: {
		color: 'indigo',
		orientation: 'horizontal',
	},
});

const Separator = React.forwardRef<
	React.ElementRef<typeof SeparatorPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> &
		VariantProps<typeof separatorVariants>
>(({ className, color, orientation, size, decorative = true, ...props }, ref) => (
	<div>
		<SeparatorPrimitive.Root
			ref={ref}
			decorative={decorative}
			orientation={orientation}
			className={cn(separatorVariants({ color, orientation, size, className }))}
			{...props}
		/>
	</div>
));

Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
